const CONTENT_LIMIT_EXCEEDED_PATTERN = /document content exceeds.*tokens?/i;

export function isContentLimitExceededError(message: unknown): boolean {
  return typeof message === 'string' && CONTENT_LIMIT_EXCEEDED_PATTERN.test(message);
}
